import React, { useEffect } from 'react'
import './privacy-policy.styles.scss';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import { useSelector } from 'react-redux';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    // Icon links: <a href="https://www.flaticon.com/free-icons/cards" title="cards icons">Cards icons created by Victoruler - Flaticon</a>

    useEffect(() => {
        changeDocumentTitle('Privacy Policy');
    }, [])

    return (
        <UnauthLayout>
            <div className={`privacy-container ${screenSize}`}>
                {/* <div className='g-space-2'></div> */}
                <div className='info-card g-card'>
                    <div className='card-title'>
                        Privacy Policy
                    </div>
                    <div className="g-space-1"></div>
                    <div className='meta'>Last updated April 26, 2025</div>
                    <hr />
                    <div className='privacy-content'>
                        <p>
                            For general guidlines for the use of our services, read our <Link href="/terms">Terms of Use</Link>.
                        </p>
                        <p>
                            Gamably.com (<b>"Gamably"</b>) takes the privacy of its users, 
                            especially teachers and students 
                            seriously. Among other things, we have committed to only collect 
                            student information that is 
                            needed for authorized education/school purposes, or as 
                            authorized by the parent/student, 
                            to not sell student personal information, to not use student 
                            information for behavioral targeting 
                            of advertisements to students and to not retain student personal 
                            information beyond the time 
                            period required to support the authorized educational/school purposes.
                        </p>
                        <p>
                            We are committed to creating a safe and secure environment for 
                            game managers, players, and learners of all ages on our 
                            websites located at <a href="https://gamably.com">https://gamably.com</a>, 
                            other websites, 
                            and online services (collectively, <b>“Website”</b>). Visitors and 
                            users of the Website and 
                            participants in our gamification management platform are referred 
                            to individually 
                            as <b>“User”</b> and collectively as <b>“Users”</b>. Users who create 
                            or manage a game 
                            (called a <b>"Game"</b> or collectively called <b>"Games"</b>) are 
                            referred to as 
                            a <b>"Game Manager"</b> or <b>"Game Managers"</b>. Users who play a game are 
                            referred to as 
                            a <b>"Player"</b> or collectively as <b>"Players"</b>.
                        </p>
                        <p>
                            Our Privacy Policy describes what information we gather from our Users, 
                            how we use that 
                            information, and what we do to protect it. Your use of the Website and 
                            any information 
                            you provide on the Website are subject to the terms of this Privacy 
                            Policy, which is 
                            incorporated into and subject to our <Link to="/terms">Terms of 
                            Use</Link>. Any capitalized 
                            terms used but not defined within this Privacy Policy have the meaning 
                            given to them in 
                            our <Link href="/terms">Terms of Use</Link>. By visiting or using our 
                            Website, you expressly 
                            consent to the information handling practices described in this Privacy 
                            Policy. If you have 
                            any questions or concerns, please contact Adam 
                            at <a href="mailto:adam@gamably.com" target="_blank" rel="noreferrer">
                            adam@gamably.com</a>.
                        </p>

                        {/* <h4>Note: Gamably uses best practices to secure data, but by visiting or using our Website, users will indemnify, defend and hold Gamably harmless from any damages, costs, losses, fines, claims, demands, suits, actions or causes of action in law or in equity, in state or federal court, or before any administrative body that are caused by or arise out of any unauthorized access to Gamably's saved data by a third party.</h4> */}

                        <h3>Data Storage and Transfer</h3>
                        <p>
                            All data saved by Gamably including email/password authentication data, Google SSO 
                            authentication data, and all data submitted or uploaded to Gamably is housed in the 
                            United States and is managed by Google's Firebase Cloud Storage. For more information 
                            on Firebase's Privacy Policies, visit <a 
                                href="https://firebase.google.com/support/privacy" 
                                target="_blank" rel="noreferrer"
                            >this website</a>. 
                            For information regarding Firebase's handling of datatransfer including international 
                            datatransfer, visit <a 
                                href="https://firebase.google.com/support/privacy#international_data_transfers"
                                target="_blank" rel="noreferrer"
                            >this website</a>.
                        </p>
                        <h4>Firebase Data Processing</h4>
                        <p>
                            Gamably uses Firebase to store and process User data. Firebase is a service provided by
                            Google, Inc. Firebase is a cloud-based platform that provides a variety of services,
                            including real-time databases, authentication, and hosting. Firebase is designed to
                            help developers build and scale applications quickly and easily. Firebase is a
                            powerful tool that allows developers to create applications that can handle large
                            amounts of data and traffic. 
                        </p>
                        <p>
                            Firebase uses subprocessors to provide its services. These subprocessors may include 
                            third-party vendors and service providers that help Firebase operate and maintain its services.
                            Firebase has implemented appropriate safeguards to protect the personal data of its users
                            when using subprocessors. These safeguards include data encryption, access controls, and
                            regular security audits. Firebase also requires its subprocessors to comply with applicable
                            data protection laws and regulations, including the General Data Protection Regulation (GDPR)
                            and the California Consumer Privacy Act (CCPA). Firebase has 
                            a <a href="https://firebase.google.com/terms/subprocessors" target="_blank" rel="noreferrer">list 
                            of its subprocessors</a> available 
                            on its website, which includes information about the types of data that each 
                            subprocessor processes and the purposes for which that data is used. By using Firebase, 
                            Gamably has entered into agreements with Firebase's third-party subprocessors 
                            ensuring they adhere to data protection standards no less stringent than those outlined in 
                            this Privacy Policy and any signed Data Privacy Agreements. Furthermore, all Gamably employees 
                            and agents who have access to Student Data are required to sign confidentiality agreements 
                            and comply with all applicable provisions of this Privacy Policy. 
                            {/* All Gamably employees must also 
                            pass a criminal background check before being employed. */}
                        </p>
                        <h4>Firebase Security</h4>
                        <p>
                            Firebase takes security seriously and has implemented a variety of measures to protect 
                            the personal data of its users. These measures include data encryption, access controls, 
                            and regular security audits. Specifically, Cloud Firestore, Cloud Functions for Firebase, 
                            and Cloud Storage for Firebase have successfully completed the ISO 27001, ISO 27017, ISO 27018, SOC 1, SOC 2,
                            and SOC 3 audits. These audits are conducted by independent third-party auditors and 
                            assess the security and privacy controls of Firebase's services. The results of these audits
                            are available to customers upon request.
                            For more information about Firebase's security practices, 
                            visit <a href="https://firebase.google.com/support/privacy#firebase_is_certified_under_major_privacy_and_security_standards" target="_blank" rel="noreferrer">this website</a>.
                        </p>
                        <h3>Cookies</h3>
                        <p>
                            Cookies are small data files that are commonly stored on your device when you use websites 
                            and on-line services. They are widely used to make websites work, or to work more efficiently, 
                            as well as to provide reporting information and assist with services or personalization. 
                            There are also other technologies that are similar to cookies, which may store small amount 
                            of data on your device ("local storage"). Gamably uses cookies only for the purpose of 
                            authenticating User accounts through the Firebase Database Authentication system, and this 
                            is only for Users who create an account using one of the methods described <a href="#userAccounts">below</a>.
                        </p> 
                        <p>
                            If you wish to disable the use of Cookies, you may do so from your browser preferences menu 
                            of your browser software by either turning off Cookies or by using your browser’s privacy 
                            mode when using our services.
                        </p>
                        <h3>Collection and Use of Your Information</h3>
                        <p>
                            The sections below describe the ways Gamably collects and uses personal data, which refers 
                            to any information that identifies you as an individual (directly or indirectly). This 
                            includes things like the name, display name, email address, etc. from Users (“Personal 
                            Information”), and persistent cookies or IP addresses (“Persistent Identifiers”). 
                            For a specific list of the data we collect, <a href="#collectedData">click here</a>. 
                            We collectively refer to any of this data we collect from Users, along with any Personal 
                            Information and User-generated content as <b>“User Data.”</b>
                        </p>
                        <p>
                            Our collection, use, and disclosure of User Data are governed by our Privacy Policy 
                            and <Link href="/terms">Terms of Use</Link>, and where applicable, also by the provisions 
                            of the Family Educational Rights and Privacy Act (FERPA), the Children's Online Privacy 
                            Protection Act (COPPA), the General Data Protection Regulation (GDPR), and other applicable 
                            federal and state laws that relate to the collection of User Data, including California’s 
                            Student Online Personal Information Protection Act (SOPIPA) and similar state laws. <b>
                                Gamably shall not use User Data for any purposes other than those authorized pursuant 
                            to our Terms of Use, Privacy Policy, and any applicable agreement.</b>
                        </p>
                        <h4>COPPA Parent Permission</h4>
                        <p>
                            Under the licensing agreement between Gamably and any teachers using the Gamably software, 
                            the teachers are responsible for obtaining parental permission should it be required under 
                            COPPA. Gamably does provide information for teachers along with a sample parental permission 
                            document should they require one. This is available on <a href="/coppa" target="_blank">
                            this page</a>.
                        </p>
                        <h4>GDPR</h4>
                        <p>
                            Gamably is committed to protecting the privacy of our users and customers. This privacy 
                            policy explains how we collect, use, share, and protect personal information in accordance 
                            with the General Data Protection Regulation (GDPR). Gamably is a data processor and does 
                            not control the data that is submitted to the service. Gamably does not use the data for 
                            any purpose other than to provide the service, nor do we 
                            sell or rent the data to any third parties. Gamably does not use the data for
                            advertising or marketing purposes. 
                        </p>
                        <h3>Users Without Accounts</h3>
                        <p>Users who create or manage a game (called a <b>"Game"</b> or collectively called <b>
                            "Games"</b>) can also add a User (called a <b>"Player"</b>) or Users (collectively called <b>
                                "Players"</b>) to their game without requiring the User(s) to create an account. Game 
                            creators or managers do not have to provide any Personal Information for the user to create that user 
                            within their Game. When creating a Game, game leaders or managers choose which type 
                            of rostering system they want to use. The options are 1) to create users who exist in 
                            that Game only, or 2) allow users to join the Game by creating a User account and joining 
                            with a join code. This section of the Privacy Policy only pertains to Players created by a 
                            game manager within one Game (option 1).
                        </p>
                        <p>
                            If a game leader chooses to create Users, he or she can do so by uploading a .CSV of Users 
                            or by inputting them one at a time. The only information required to create a user is a name, 
                            which can be a username, a number, or the person's actual name. There are inputs for a first 
                            name and a last name, but only the first name is required, and that does not need to be an 
                            actual name. There is also an input for "Info" which can be any other identifying details 
                            about a person, but again, it should not be Personal Information. This "Info" is purely for 
                            the benefit of the game leader and the Users in the World. When the User account is created 
                            in this manner, an icon will be assigned to the account and a four-digit password will be 
                            generated. That sign in information will be provided to the game leader to disseminate however 
                            he or she chooses.
                        </p> 

                        <p>
                            Users whose accounts are created this way cannot change their display name or upload a unique 
                            icon, they do not have access to join other Worlds, nor can they create their own Worlds. 
                            The User information is protected on Google servers in the United States and can only be 
                            accessed by Gamably and by the game leader.
                        </p>

                        <a 
                            id="userAccounts"
                            style={{"display": "none"}}></a>
                        <h3>Users Who Create Personal Accounts</h3>
                        <p>
                            Users do have the ability to create an account by providing a valid email address and 
                            creating a password, or by signing in using Google's SSO Authentication Service 
                            using Firebase Auth services. Users can only create games if they have created 
                            an account within Gamably and are over the age of 16 (according to a User-provided birthdate).
                        </p>

                        <h4>Creating an account with a valid email</h4>
                        <p>
                            Users can create an account by providing a valid email address and password. The platform
                            validates emails by sending Users a validation link. Passwords are required to be at least
                            six characters long and include a lowercase letter, an uppercase letter, a number, and a 
                            special character (!, *, &, #). These users do not have 
                            to submit any other Personal Information. They are asked for a first name and last name, 
                            but those do not need to be the User's real name. Also, the password provided is stored 
                            in Gamably's database system as a hash created by Google's Firebase servers. Gamably does not have 
                            access to any User's created password, and thus does not share that information or make 
                            it public. For more information about Firebase's password hashing, 
                            visit <a href="https://firebaseopensource.com/projects/firebase/scrypt" target="_blank" rel="noreferrer">this website</a>. 
                            If users want to change their passwords, they can do so by clicking "Forgot 
                            my password" on the sign in page.
                        </p>

                        <h4>Creating an account with Google Authentication</h4>
                        <p>
                            If you decide to register for a Gamably account through Google's Authentication Service, 
                            you give Gamably the permission to store and use information already associated with your 
                            Authentication Service consistent with this Privacy Policy and the table below. When 
                            using third-party authentication systems, Gamably may receive personal data (such as 
                            a User's full name or gender) that is not required for use of the Website. However, 
                            Gamably uses Google's Authentication Service only to authenticate the User's account 
                            and has no access to the User's password or anything else associated with that account 
                            aside from the information the user has provided to Google and has made public. 
                            Gamably only uses the User's email, display name, and icon.
                        </p>
                        
                        <p>
                            You may revoke Gamably’s access to your account on any Authentication Service at any 
                            time by updating the appropriate settings in the <a 
                            href="https://myaccount.google.com/permissions" 
                            target="_blank" rel="noreferrer">Google Account Permissions Preferences</a>. You should check your 
                            privacy settings on your Google account to understand and change the information 
                            sent to us. Please review Google’s <a 
                            href="https://policies.google.com/terms" 
                            target="_blank" rel="noreferrer">terms of use</a> 
                            and <a 
                            href="https://policies.google.com/privacy" 
                            target="_blank" rel="noreferrer">privacy policies</a> carefully 
                            before using their services and connecting to our Website.
                        </p>

                        <a id="collectedData"></a>
                        <h3>Data Collected by Gamably</h3>
                        <p>
                            Gamably collects the minimum required amount of User data for service from the platform. 
                            The data collected is listed below:
                        </p>
                        <table className="uk-table uk-table-responsive">
                            <tr>
                                <td className='data-header'>
                                    <p className="bold"><b>IP Address (required)</b></p>
                                </td>
                                <td>
                                    <p>
                                        Collected when a User visits Gamably.com. This 
                                        information is not stored in Gamably's database, 
                                        but it is used by Google Analytics to help Gamably 
                                        understand usage trends. It cannot be associated
                                        with any specific user's account.
                                    </p>                                    
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className="bold"><b>Cookie Data (required)</b></p>
                                </td>
                                <td>
                                    <p>
                                        As described above, Gamably uses cookies to handle
                                        authentication and is required during use of the platform.
                                        This data is not stored in Gamably's database. Users can disable 
                                        cookies in their browser settings, 
                                        however, they will not be able to fully use the platform without
                                        the use of cookies.
                                    </p>                                    
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className="bold"><b>Email Address</b></p>
                                </td>
                                <td>
                                    <p>
                                        Collected ONLY when a User creates an account in 
                                        Gamably through one of the two methods 
                                        described <a href="#userAccounts">above</a>. 
                                        This is used to create a User's profile and to 
                                        give them access to the Games in which they are 
                                        enrolled or which they have created. It is 
                                        viewable only to the game manager of the 
                                        Games in which the players are enrolled.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>User's Name</b></p>
                                </td>
                                <td>
                                    <p>
                                        Collected ONLY when a User creates an account in 
                                        Gamably through one of the two methods 
                                        described <a href="#userAccounts">above</a>. This 
                                        information can be viewed by Game creators and 
                                        managers and other Players within the Game. This 
                                        data is not public and is not available to
                                        anyone outside of the Game in which the User is
                                        enrolled.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>Birthdate</b></p>
                                </td>
                                <td>
                                    <p>
                                        Collected ONLY when a User creates an account in 
                                        Gamably through one of the two methods 
                                        described <a href="#userAccounts">above</a>. This 
                                        information is not public, nor is it viewable by 
                                        Game creators or managers. It is used only to regulate 
                                        the options available to Users. For example, Users 
                                        16 years old and under cannot upload a User icon, 
                                        nor can they create their own Game.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>School or Organization Name (optional)</b></p>
                                </td>
                                <td>
                                    <p>
                                        Collected ONLY when a User creates an account in Gamably 
                                        through one of the two methods 
                                        described <a href="#userAccounts">above</a>. This information 
                                        is not made public, nor is it viewable by Game creators or 
                                        managers. This is used by Gamably staff only for usage 
                                        demographics and support.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>Purpose for Using Gamably (optional)</b></p>
                                </td>
                                <td>
                                    <p>
                                        Collected ONLY when a User creates an account in Gamably 
                                        through one of the two methods 
                                        described <a href="#userAccounts">above</a>. This 
                                        information is not made public, nor is it viewable by 
                                        Game creators or managers. This is used by Gamably 
                                        staff only for usage demographics and support.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>In-App Progress and Earnings</b></p>
                                </td>
                                <td>
                                    <p>
                                        This data is for gameplay purposes only and is not 
                                        available to Users outside the constraints of their 
                                        particular Game. The only exception to this is 
                                        through the use of a public leaderboard. For more 
                                        information about what data is shared through 
                                        leaderboards, <a href="#leaderboards">click here</a>.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>Files or Data Uploaded to the App</b></p>
                                </td>
                                <td>
                                    <p>
                                        Throughout the use of the app, Users can upload or 
                                        submit files, links, or text to complete objectives. 
                                        That submitted data is only available to the User 
                                        and the Game manager. However, once the objective 
                                        is approved or declined, the uploaded data is deleted
                                        from Gamably's database. This data is not the property 
                                        of Gamably and if it is not removed by the platform,
                                        it can be removed at any point. To remove 
                                        submitted data, the Game manager can request it be 
                                        removed by 
                                        emailing <a href="mailto:adam@gamably.com">adam@gamably.com</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className='data-header'>
                                    <p className='bold'><b>Payment Data</b></p>
                                </td>
                                <td>
                                    <p>
                                        We use Stripe to process any purchases made on the platform. 
                                        Stripe will collect data necessary to process your payment if 
                                        you make purchases, such as your payment instrument number, 
                                        and the security code associated with your payment instrument. 
                                        All payment data is stored by Stripe. You may find their privacy 
                                        notice link(s) here: <a href="https://stripe.com/en-gb-us/privacy"
                                        target="_blank" rel="noreferrer">https://stripe.com/en-gb-us/privacy</a>.
                                    </p>
                                </td>
                            </tr>
                        </table>


                        <p>
                            Data like IP addresses that are de-identified and not associated with an existing User account
                            will not be re-itendified or reassociated. 
                        </p>
                        <p>
                            Similarly, Gamably does not collect any individual student biometric data, User data 
                            relative to analysis of facial expressions, EEG brain wave patterns, skin conductance, 
                            galvanic skin response, heart-rate variability, pulse, blood volume, posture, and 
                            eye-tracking. Gamably also does not collect or monitor:
                        </p>
                        <ul>
                            <li>Location-tracking features of any User's device;</li>
                            <li>Audio or visual receiving, transmitting or recording features of a User's device;</li>
                            <li>User interactions with a device, including, but not limited to, keystrokes and 
                                web-browsing activity</li>
                        </ul>
                        <p>        
                            Collected information is used for the following purposes:
                        </p>
                        <ul>
                            <li>To allow Users to create and manage a Game;</li>
                            <li>To allow Users to participate and interact within a Game;</li>
                            <li>
                                To enable Game-related activities such as challenges, 
                                quests, and secret codes;
                            </li>
                            <li>
                                To allow Game managers and players to compare individual or 
                                group performance against others within each Game;
                            </li>
                            <li>For software support purposes, and</li>
                            <li>For billing purposes</li>
                        </ul>

                        <h4>Changing or Deleting Information</h4>
                        <p>
                            Users who create accounts through the methods 
                            described <a href="#userAccounts">above</a> can change their 
                            Personal Information by editing their profile after
                            signing into their account or by contacting Gamably 
                            at <a 
                                href="mailto:adam@gamably.com" 
                                target="_blank" rel="noreferrer">
                                adam@gamably.com
                            </a>. 
                            To delete an account, please contact Gamably 
                            at <a 
                                href="mailto:adam@gamably.com" 
                                target="_blank" rel="noreferrer">
                                adam@gamably.com
                            </a>.
                        </p>
                        <a 
                            id="leaderboards"
                            style={{'display':'none'}}>    
                        </a>
                        
                        <h4>Information Displayed Within Inhabitant Account Pages</h4>
                        <p>
                            By default, Users can see Game events for other Users in their 
                            Game from within their account. They can see what was earned 
                            on what date, but they cannot see more information, such as 
                            how the items were earned or the Game creator's or manager's 
                            comments.
                        </p>

                        <h3>User Access Privileges</h3>
                        <p>
                            Game creators and managers have default access to the User Data 
                            described above for the Players in their Game(s), but not for 
                            any players in Games that they did not create. However, Game 
                            creators can add managers who are older than 16 years of age, 
                            and those managers will have access to the same User Data that 
                            the Game creators do. They can also have access to interactive 
                            elements in the Game like distribution and creation of items, 
                            badges, levels, etc. Only Game creators have the ability to add 
                            managers, and a manager cannot add him or herself to a Game.
                        </p>
                            
                        <p>
                            Players are granted access to their personal data within the Game, 
                            their group game play data, all content created and posted by Game 
                            managers, basic information about the progress and earnings of 
                            other Players (not including leader or manager comments, or the 
                            way in which items, badges, points and/or currency were earned) 
                            as well as any data that is displayed by the teacher in front of 
                            the whole class.
                        </p>

                        <h3>Dealing With Records in a Classroom Setting</h3>
                        <p>
                            When used in a classroom setting, Gamably acts as a "School Official" 
                            with a legitimate educational interest under the direct control and 
                            supervision of the Local Education Agency (LEA) regarding the use 
                            of Student Data, as defined by FERPA and similar privacy laws. 
                            Gamably does not
                            use any student data for any purpose other than to provide the
                            service to the school and/or district. Gamably does not sell or rent
                            any student data to any third parties. Gamably does not use student
                            data for advertising or marketing purposes. Gamably does not use
                            student data to create profiles of students or to track students
                            across different websites or services. Gamably does not use student
                            data to create targeted advertising or to sell advertising space.
                        </p>
                        <h4>Student Records</h4>
                        <p>
                            If Gamably is used in a classroom setting, the following information 
                            is considered student records: student game play information, such 
                            as XP, currency, items, and/or badges earned, and all related data 
                            including User-created content that has been submitted through 
                            Challenges and Quests and comments received from Game creators or 
                            managers while completing said Quests and/or Challenges. All Student 
                            Data provided to Gamably by an LEA for the purpose of providing our 
                            services remains the exclusive property of, and under the sole control 
                            of, the LEA. Gamably acknowledges and agrees that all copies, 
                            modifications, or additions to such Student Data are subject to the 
                            same terms and protections as the original data.
                        </p>
                        <p>
                            Further, 
                            data uploaded to Challenges or Quests is deleted from Gamably's 
                            database as soon as the Challenge
                            is either approved or declined by a Game manager. While in Gamably's
                            database, the uploaded data will not be used by Gamably for anything 
                            outside of the constraints of the Game in which the data was 
                            submitted. This data will not be kept longer than 12 months after 
                            the last activity was recorded in the Game. Gamably supports the LEA's 
                            obligations under FERPA concerning parent and eligible student rights. 
                            Should a parent, legal guardian, or eligible student contact Gamably 
                            directly to review or request corrections to Student Data, we will 
                            refer them to the relevant LEA, who will follow their established 
                            procedures. Gamably will respond to LEA requests for Student Data 
                            review or correction within forty-five (45) days, or sooner if required 
                            by applicable state law.
                        </p>
                        <h4>Access to Student Records</h4>
                        <p>
                            Student records are the property of and under the control of the school 
                            and/or school district. Students can access their student records by 
                            logging in to their student account. Parents of students under the age 
                            of 18 can access their child’s information by logging in using their 
                            child’s account, by contacting the teacher or by contacting Gamably 
                            at <a href="mailto:adam@gamably.com" target="_blank" rel="noreferrer">adam@gamably.com</a>. 
                            Corrections of any erroneous information should first be brought to the 
                            attention of the teacher or the school administration. In the event 
                            that the teacher or school are unable to make the correction, parents 
                            should advise Gamably at <a 
                                href="mailto:adam@gamably.com" 
                                target="_blank" rel="noreferrer">
                                adam@gamably.com
                            </a> who will then work with the teacher or school to facilitate 
                            correction of any erroneous information. Third parties are not 
                            granted access to personally identifiable information or educational 
                            records or other student records except as provided in this Privacy 
                            Policy, or after first obtaining the express written consent of the 
                            parent or student over 18 years of age. Should there be any 
                            unauthorized disclosure of a student’s records, Gamably will notify 
                            the school, teacher, parent and student via email within 3 days 
                            following discovery of the unauthorized disclosure.
                        </p>

                        <h4>No Marketing to Students and Parents</h4>
                        <p>
                            Gamably does not share user data with third parties for marketing 
                            purposes. Furthermore, Gamably does not use student data for marketing 
                            of any kind, including both marketing to student and to parents.
                        </p>

                        <h3>User-created Game Content</h3>
                        <p>
                            Game Creators and Managers may make postings in various 
                            sections within a Game on the Gamably platform. These posts appear 
                            in the form of announcements that all Players within that Game can see 
                            and Challenge or Quest Checkpoint prompts. These posts can include text
                            and/or links. Players can also create and submit content to the Game
                            through the use of Challenges and Quests. However, this content is only
                            viewable by Game Creators and Managers and is not 
                            viewable by other Players within the platform.
                            It is the responsibility of the User submitting the content to ensure 
                            that this content is appropriate and free from links to sites which may 
                            compromise the privacy of other Users. Gamably does not monitor the 
                            Game content and has no responsibility for this content. 
                        </p>
                        <p>
                            If student-generated content (e.g., submissions to Challenges and Quests) is 
                            stored, Gamably will, upon request from the LEA, transfer or provide a 
                            mechanism for the LEA to transfer this content to a separate student account.
                        </p>

                        <h3>Change of Control</h3>
                        <p>
                            In the event that all or a portion of Gamably or its assets are acquired 
                            by or merged with a third party, personal information that we have 
                            collected from users would be one of the assets transferred to or acquired 
                            by that third party. This Privacy Policy will continue to apply to your 
                            information, and any acquirer would only be able to handle your personal 
                            information as per this policy (unless you give consent to a new policy). 
                            We will provide you with notice of an acquisition within thirty (30) days 
                            following the completion of such a transaction, by posting on our homepage, 
                            and/or by email to the email address that you provided to us. If you do 
                            not consent to the use of your personal information by such a successor 
                            company, you may request its deletion from the company. In the unlikely 
                            event that Gamably goes out of business, all user information will be 
                            securely deleted within 12 months of the date of going out of business.
                        </p>

                        <h3>Disclosure of Information to Satisfy Legal Obligations</h3>
                        <p>
                            Gamably may disclose personal information if we have a good faith belief 
                            that doing so is necessary to comply with the law, such as complying with 
                            a subpoena or other legal process. We may need to disclose personal 
                            information where, in good faith, we think it is necessary to protect the 
                            rights, property, or safety of Gamably, our employees, our community, or 
                            others, or to prevent violations of our our Terms of Service or other 
                            agreements. This includes, without limitation, exchanging information with 
                            other companies and organizations for fraud protection or responding to 
                            government requests. In a school setting,  Gamably will notify the LEA in 
                            advance of any compelled disclosure of Student Data to law enforcement or 
                            other government entities, unless legally prohibited from doing so.
                        </p>

                        <h3>Data Retention and Secure Destruction</h3>

                        <p>
                            Gamably is committed to the secure and timely destruction of Student Data when it 
                            is no longer needed for authorized educational purposes or as requested by the 
                            LEA. Our practices align with federal laws like FERPA and COPPA, and applicable 
                            state student privacy laws.
                        </p>
                        
                        <h4>Data Retention Periods:</h4>

                        <p>
                            User-Submitted Content: Files, links, or text uploaded by Players to complete 
                            objectives (e.g., Challenges and Quests) are promptly deleted from Gamably's 
                            database as soon as the objective is approved or declined by a Game Manager. This 
                            ensures that transient, objective-specific data is not retained beyond its 
                            immediate educational purpose.
                        </p>
                        <p>
                            Game Play Information (Student Records): Student game play information, such as 
                            XP, currency, items, badges earned, and related data including Game Manager comments, 
                            will not be kept longer than twelve (12) months after the last activity was 
                            recorded in the Game. This period is aligned with common best practices for 
                            retaining educational records for their intended pedagogical value.
                        </p>
                        <p>
                            Account Information (for created accounts): For Users who create accounts through 
                            email/password or Google SSO, their account information (email address, display name, 
                            birthdate, optional school/organization name, purpose for using Gamably) will be 
                            retained as long as the account is active or until a deletion request is made. This 
                            is necessary to maintain the user's profile and access to Games.
                        </p>
                        
                        <h4>Deletion Procedures:</h4>

                        <p>
                            Upon Request from LEA/Parent/Eligible Student: Upon written request from an LEA, or 
                            a parent/eligible student (via the LEA or directly to Gamably as described in the 
                            "Changing or Deleting Information" section), Gamably will securely dispose of or 
                            provide a mechanism for the LEA to transfer Student Data obtained under the Service 
                            Agreement. Such requests will be fulfilled within forty-five (45) days of the date of 
                            the request, or sooner if required by specific state law, and according to a schedule 
                            and procedure reasonably agreed upon by the parties.
                        </p>
                        <p>
                            Upon Termination of Services: If no written request for data return or deletion is 
                            received from the LEA upon termination of our services agreement, Gamably will dispose 
                            of all Student Data after providing the LEA with reasonable prior notice (typically 
                            30-60 days to allow for data retrieval).
                        </p>

                        <p>
                            In the unlikely event that Gamably ceases operations, all user information, including 
                            Student Data, will be securely deleted within twelve (12) months of the date of going 
                            out of business.
                        </p>
                        
                        <h4>Method of Data Destruction:</h4>
                        <p>
                            Gamably employs industry-standard secure data deletion methods to ensure that Student 
                            Data cannot be reconstructed or retrieved once it has been destroyed. This includes, 
                            but is not limited to, cryptographic erasure or physical destruction of storage 
                            media where appropriate. For data stored in Google's Firebase Cloud Storage, we adhere 
                            to their secure deletion protocols.
                        </p>

                        <h4>Exceptions to Deletion:</h4>
                        <p>
                            The duty to dispose of Student Data does not extend to:
                        </p>
                        <ul>
                            <li><b>De-Identified Data:</b> Data that has been appropriately de-identified in 
                            accordance with FERPA and other applicable laws, such that it cannot reasonably 
                            be used to identify an individual student, may be retained and used for purposes 
                            such as product improvement, research, and analysis. Gamably agrees not to attempt 
                            to re-identify de-identified Student Data.
                            </li>
                            <li><b>Student-Generated Content Transferred to Personal Account: </b>Student-generated 
                            content that has been transferred to a separate personal account created by the student 
                            at the request of the LEA.
                            </li>
                            <li><b>Data Required for Legal Compliance: </b>Data that Gamably is legally required 
                            to retain by federal or state law, or for legitimate business purposes such as 
                            auditing our compliance with legal and contractual obligations.
                            </li>
                        </ul>

                        <h3>Data Security Incidents and Breach Notification</h3>
                        
                        <p>
                            Gamably takes the security of User Data, especially Student Data, with the utmost 
                            seriousness. We implement and maintain reasonable security measures, including administrative, 
                            technical, and physical safeguards, to protect against unauthorized access, disclosure, 
                            alteration, and destruction of data under our control.
                        </p>

                        <p>
                            In the unfortunate event of an unauthorized acquisition, access, use, or disclosure 
                            of Student Data or other regulated personal information (a "Security Incident" or "Data 
                            Breach"), Gamably commits to the following procedures:
                        </p>

                        <ol>
                            <li><b>Prompt Internal Response:</b> Upon discovery of a potential Security Incident, 
                            Gamably will immediately initiate an internal investigation to:
                                <ul>
                                    <li>Assess the nature and scope of the incident.</li>
                                    <li>Identify the data affected and the individuals potentially impacted.</li>
                                    <li>Contain the incident to prevent further unauthorized access or harm.</li>
                                    <li>Implement remedial measures to restore the integrity and security of our systems.</li>
                                </ul>
                            </li>
                            <li><b>Notification to Local Education Agency (LEA):</b> 
                                <ul>
                                    <li><b>Timely Notification: </b>Gamably will notify the affected Local 
                                    Education Agency (LEA) promptly and without undue delay, but in no event later than 
                                    three (3) days following the discovery of an unauthorized disclosure or acquisition of 
                                    Student Data. This notification will be sent via email to the primary contact designated 
                                    by the LEA, and where available, any other designated security contacts.
                                    </li>
                                    <li><b>Information Provided in Notification: </b>The initial notification will, to the 
                                    extent known at the time, include:
                                        <ul>
                                            <li>The date and time of the incident's discovery.</li>
                                            <li>A description of the nature of the breach.</li>
                                            <li>The categories and approximate number of individuals and Student Data records 
                                                concerned.</li>
                                            <li>The likely consequences of the Data Breach.</li>
                                            <li>A description of the measures taken or proposed by Gamably to address the 
                                                breach and mitigate any possible adverse effects.</li>
                                            <li>The contact information for Gamably's point of contact for further information.</li>
                                        </ul>
                                    </li>
                                    <li><b>Ongoing Communication: </b>Gamably will provide the LEA with regular updates as the 
                                    investigation progresses and additional information becomes available.
                                    </li>
                                </ul>
                            </li>
                            <li><b>Notification to Affected Parties (Students, Parents):</b>
                                <ul>
                                    <li><b>LEA's Responsibility: </b>As the owner and controller of Student Data, the LEA
                                    (school/school district) is primarily responsible for notifying affected students, 
                                    parents, and other relevant parties, as required by FERPA, COPPA, and applicable 
                                    state laws.
                                    </li>
                                    <li><b>Gamably's Assistance: </b>Gamably will cooperate fully with the LEA's efforts to
                                    notify affected parties, providing all necessary information and support to facilitate 
                                    compliance with notification obligations.
                                    </li>
                                    <li><b>Direct Notification by Gamably (in specific cases): </b>In rare circumstances 
                                    where Gamably is directly required by law to notify affected individuals (e.g., if 
                                    we are deemed the "owner" of certain data under a specific state law, or in non-LEA 
                                    contexts), we will do so in compliance with all applicable legal requirements.
                                    </li>
                                </ul>
                            </li>
                            <li><b>Notification to Credit Reporting Agencies:</b>
                                <ul>
                                    <li>Gamably will comply with all legal obligations to notify relevant governmental 
                                        or regulatory authorities, such as state attorneys general or the Student 
                                        Privacy Policy Office (SPPO) at the U.S. Department of Education, if required 
                                        by applicable federal or state law.
                                    </li>
                                </ul>
                            </li>
                            <li><b>Record Keeping:</b>    
                                <ul>
                                    <li>Gamably will maintain a comprehensive record of all Security Incidents, regardless
                                        of whether notification is required, including the facts relating to the 
                                        incident, its effects, and the remedial actions taken.
                                    </li>
                                </ul>
                            </li>
                            <li><b>Cooperation with Investigation:</b>
                                <ul>
                                    <li>Gamably will cooperate with and assist the LEA in any investigation related to 
                                        a Security Incident involving Student Data under Gamably's control.
                                    </li>
                                </ul>
                            </li>
                        </ol>

                        <h3>Changes and Updates to the Privacy Policy</h3>
                        <p>
                            This Privacy Policy is effective as of April 26, 2025 and is version 1.2. 
                            Gamably may, at its sole discretion, update, revise, modify and supplement 
                            from time to time this Privacy Policy. Should we make modifications to 
                            this policy or any other agreements, we’ll post a notice that you will 
                            receive when you login to the game and/or we will send an email directly 
                            to you with a copy of the new documents. Gamably's updated Privacy Policy 
                            and User Agreements will also be posted on Gamably's public facing website,
                            and we will not require users to have an account to view them. 
                            Gamably asks users to review the updated Privacy Policy and/or agreements 
                            before continuing to use our services. If users do not accept the updated 
                            Privacy Policy users can remove their information by contacting us 
                            at <a href="mailto:adam@gamably.com" target="_blank" rel="noreferrer">adam@gamably.com</a>. 
                            The user’s continued use of the services provided by Gamably after the 
                            updated Privacy Policy takes effect will constitute user’s acceptance of 
                            the updated Privacy Policy.
                        </p>

                        <h3>Consent to the Gathering and Processing of Information</h3>
                        <p>
                            By using Gamably's services and website, Users accept the Terms of Use and 
                            Privacy Policy and are expressly giving Gamably a special declaration that 
                            Users have decided by their own free will to grant Gamably specific 
                            authorization to collect, process and use the personal information 
                            stipulated in this Privacy Policy and to use such information in accordance 
                            with what is stipulated in this Privacy Policy. Users are further declaring 
                            that users are aware of the purpose for Gamably collecting, processing 
                            and using such information, how the processing will be conducted, how 
                            users’ privacy will be protected and that users are authorized to withdraw 
                            their consent.
                        </p>

                        <h3>Contact</h3>
                        <p>
                            Gamably's service to its users and users’ trust is of utmost importance 
                            to Gamably. If users have any questions about this Privacy Policy, users 
                            should contact Gamably at <a 
                                href="mailto:adam@gamably.com" 
                                target="_blank" rel="noreferrer">
                                adam@gamably.com
                            </a>.
                        </p>
                    </div>
                </div>
                <div className='g-space-2'></div>
                <InfoLinks />
            </div>
        </UnauthLayout>
        
    )
}

export default PrivacyPolicy